import classnames from 'classnames/bind'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './tooltip.module.scss'

const cx = classnames.bind(styles)

const Tooltip = ({ className, hidden, message, placement, maxWidth, minWidth, width }) => {
  const isTop = placement === 'top'
  const isRight = placement === 'right'
  const isBottom = placement === 'bottom'
  const isLeft = placement === 'left'
  const tipClassName = cx(className, styles.tooltip, {
    hidden,
    visible: !hidden,
    top: isTop,
    right: isRight,
    bottom: isBottom,
    left: isLeft
  })
  const arrowClassName = cx(styles.tooltipArrow, {
    arrowTop: isTop,
    arrowRight: isRight,
    arrowBottom: isBottom,
    arrowLeft: isLeft
  })
  const innerClassName = cx(styles.tooltipInner, {
    innerTop: isTop || isBottom,
    innerLeft: isLeft || isRight
  })

  const innerStyles = {
    width: width && !maxWidth ? width : undefined,
    maxWidth: maxWidth || !width ? maxWidth : undefined,
    minWidth
  }

  return (
    <div className={tipClassName}>
      <div className={arrowClassName} />
      <div className={innerClassName} style={innerStyles}>
        {message}
      </div>
    </div>
  )
}

Tooltip.propTypes = {
  className: PropTypes.string,
  hidden: PropTypes.bool,
  placement: PropTypes.string,
  message: PropTypes.string.isRequired,
  maxWidth: PropTypes.number,
  minWidth: PropTypes.number,
  width: PropTypes.number
}

Tooltip.defaultProps = {
  className: null,
  hidden: false,
  placement: 'bottom',
  maxWidth: null,
  minWidth: 100,
  width: null
}

export default Tooltip
